import React                      from 'react'
import { Button
       , Table }                  from 'antd'
import { Observer }               from 'mobx-react'
import moment                     from 'moment'

import { KeyIcon
       , TABLE_LOCALE
       , TEXT
       , tr
       , tr_enum_job_state }      from '../00_assets'
import { API_GENERAL_ERROR 
       , JOB_STATUS
       , kde_api_job_t }          from '../02_api'
import { Biting
       , EditButtons
       , get_job_status_id
       , ModalPrompt
       , TableState }             from '../10_ui'

import { create_job_editor_model
       , JobEditor }              from './02_screen_jobs_editor'


export const JobsTable: React.FC<
   { jobs: kde_api_job_t[]
   , onDelete: ( job: kde_api_job_t ) => any
   , onEdit: ( job: kde_api_job_t, data: Partial<kde_api_job_t> ) => any
   , onAdd:  ( job: Partial<kde_api_job_t> ) => any
   , loading: boolean
   } > = ( props ) =>
{
  const table_state = TableState( ) ;

  return <Observer render={ ( ) =>
  {
    const row_key = ( row: kde_api_job_t ) => row.id + ''
        , on_edit_job = (row: kde_api_job_t) =>
          {
            const editor_model = create_job_editor_model( row ) ;

            ModalPrompt( tr( TEXT.JOB_EDIT_TITLE )
                      , <JobEditor form={ editor_model } />
                      , ( ) => props.onEdit( row, editor_model.fields( ) as any )
                      ) ;
          }
        , dup_job = (row: kde_api_job_t) => ( ) =>
          {
            const editor_model = create_job_editor_model( row ) ;

            ModalPrompt( tr( TEXT.JOB_NEW_TITLE )
                      , <JobEditor form={ editor_model } />
                      , async ( ) =>
                        {
                          const job_status_id = await get_job_status_id( JOB_STATUS.PENDING ) ;

                          return job_status_id !== false?
                               props.onAdd(
                                  { client: { id: row.client.id }
                                  , key: { id: row.key.id }
                                  , quantity: editor_model.model.quantity.value( )
                                  , jobStatus: { id: job_status_id }
                                  , machine: { id: editor_model.model.machine_id.value( ) } } as any )
                              : API_GENERAL_ERROR( ) ;
                        }
                      ) ;
          }
        , row_className = ( job: kde_api_job_t ) => "on-hover " + job.jobStatus.name
        , complete_name = (row: kde_api_job_t) => [ row.client.name, row.client.surnames ].join( ' ' )
        , columns = [ { title: tr( TEXT.JOB_STATUS )
                      , ...table_state.sort_col( 'state'
                                               , (row: kde_api_job_t) => tr_enum_job_state( row.jobStatus.name ) )
                      , className: 'status'
                      , align: 'center' as const
                      , render: ( row: kde_api_job_t ) =>
                          <span style={{fontSize:"12px"}}>{ tr_enum_job_state( row.jobStatus.name ) }</span>
                      }
                    , { title: tr( TEXT.UI_NAME )
                      , ...table_state.sort_col( 'name'
                                               , complete_name )
                      , render: ( row: kde_api_job_t ) =>
                          <div className="flex-row flex-align-center">
                            <div className="text-truncate">{ complete_name( row ) }</div>
                          </div>
                      , width: '22%'
                      }
                    , { title: tr( TEXT.JOB_KEY_TYPE )
                      , ...table_state.sort_col( 'key'
                                               , (row: kde_api_job_t) => row.key.model )
                      , render: ( row: kde_api_job_t ) =>
                          <span className="text-mono">{ row.key.model }</span>
                      }
                    , { title: tr( TEXT.KEY_DATA_SHEET )
                      , ...table_state.sort_col( 'datasheet'
                                               , (row: kde_api_job_t) => row.key.datasheet.id )
                      , render: ( row: kde_api_job_t ) =>
                          <span>{ row.key.datasheet.id }</span>
                      }
                    , { title: tr( TEXT.KEY_BITING )
                      , key: 'bitting'
                      , render: ( row: kde_api_job_t ) =>
                          <Biting value={ row.key.biting }/>
                      }
                    , { title: tr( TEXT.JOB_NUM_KEYS )
                      , key: 'num_copies'
                      , dataIndex: 'quantity'
                      }
                    , { title: tr( TEXT.JOB_DATE )
                      , ...table_state.sort_col( 'date'
                                               , (row: kde_api_job_t) => moment( row.creationDate ).format( 'YYYYMMDD' ) )
                      , render: ( row: kde_api_job_t ) =>
                          <span>{ moment( row.creationDate ).format( tr( TEXT.UI_DATE_FORMAT ) ) }</span>
                      }
                    , { title: tr( TEXT.JOB_MACHINE )
                      , ...table_state.sort_col( 'machine'
                                               , (row: kde_api_job_t) => row.machine!.name )
                      , render: ( row: kde_api_job_t ) =>
                          <span>{ row.machine!.name }</span>
                      }
                    , { title: ''
                      , key: 'action'
                      , render: ( row: kde_api_job_t ) =>
                          <div style={{display: 'flex', flexDirection: 'row'}}>
                            <Button
                              onClick={ dup_job( row ) }
                              type="ghost"
                              className="ba-0" style={{ height: 18 }}>
                                <KeyIcon />
                            </Button>

                            { 
                              row.jobStatus.name === 'PENDING'?
                                <EditButtons
                                  show='show-visible'
                                  row={ row }
                                  onEdit={ on_edit_job }
                                  onDelete={ props.onDelete }
                                />
                              : null
                            }
                          </div>
                      , width: '95px'
                      }
                    ] ;


    return <React.Fragment>
      <Table
        className="m-3 shadow"
        loading={ props.loading }
        columns={ columns }
        dataSource={ props.jobs }
        pagination={ false }
        rowKey={ row_key }
        rowClassName={ row_className }
        locale={ TABLE_LOCALE }
        onChange={ table_state.on_table_change }
      />
      </React.Fragment> ;
  } }/> ;
}